import React, { MouseEventHandler } from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

interface Props {
  onClickFilter: MouseEventHandler<HTMLButtonElement>
  className?: string
}

const OpenFilterButton: React.FC<Props> = ({ onClickFilter, className = '' }) => {
  const { t } = useTranslation()
  return (
    <button
      type="button"
      onClick={onClickFilter}
      className={classNames(
        'md:hidden flex flex-row flex-1 items-center text-gray-icons hover:text-gray-text dark:text-gray-icons-dm',
        className
      )}>
      <i className="text-h3 nf-icon nf-filter mr-2.5" />
      <span className="font-medium text-black text-md dark:text-gray">{t('palette.filter')}</span>
    </button>
  )
}

export default OpenFilterButton
